import { InviteActionError } from "../../invites/services/inviteActionError";
import { reuseHealthcareService } from "../../services/createTeleconsultoriaSchedule";
import { organizationTokenFromId } from "../../services/teleconsultoriaScheduleService";
import type { TeleconsultoriaActor } from "../../types";

/**
 * HCS do solicitante (host) na afiliada: o mesmo das agendas clínicas dele.
 * O Appointment da teleconsultoria precisa ter o HCS de quem convida; o HCS do
 * teleconsultor entra depois, no aceite. Sem agenda na clínica, não marca.
 */
export async function resolveRequesterHealthcareService(params: {
  requester: TeleconsultoriaActor;
  affiliateOrganizationId: string;
}): Promise<TeleconsultoriaActor> {
  const found = await reuseHealthcareService({
    practitionerRef: params.requester.reference,
    organizationToken: organizationTokenFromId(params.affiliateOrganizationId),
  });
  if (!found) {
    throw new InviteActionError(
      `${params.requester.display || "O solicitante"} não tem agenda (serviço de saúde) nesta clínica. Crie uma agenda para ele antes de marcar a teleconsultoria.`,
    );
  }
  return { reference: `HealthcareService/${found.id}`, display: found.display };
}
